import { createSelector } from 'reselect';

const selectStationDataFeedUrl = (state) => {
  return state.stationData.stationDataEndpointUrl;
};

const selectStationDataFeed = (state) => {
  return state.stationData.stationDataFeed;
};

const selectFilteredStationDataFeed = (state) => {
  return state.stationData.filteredStationDataFeed;
};

export const selectStationDataUrl = createSelector(
  [selectStationDataFeedUrl],
  (stationDataUrl) => {
    return stationDataUrl;
  }
);

export const selectStationData = createSelector(
  [selectStationDataFeed],
  (stationData) => {
    return stationData;
  }
);

export const selectFilteredStationData = createSelector(
  [selectFilteredStationDataFeed],
  (filteredStationData) => {
    return filteredStationData;
  }
);